import React from "react";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";
import {
  ChartBox, CHART_MARGIN, GRID, xAxisProps, yAxisProps,
  KitTooltip, renderRefLines, normaliseSeries, compactAxis, num, EmptyState,
} from "./_kit";

/**
 * Generic multi-series line chart.
 * @param {object[]} props.data - one row per x value, keyed by xKey + series keys
 * @param {string} [props.xKey="x"]
 * @param {{key:string,name?:string,color?:string,dashed?:boolean,dot?:boolean}[]} props.series
 * @param {{x?:number,y?:number,label?:string}[]} [props.refLines]
 * @param {string} [props.unit]
 */
export function RLineChart({
  data = [], xKey = "x", series = [], refLines = [],
  unit, height = 320, formatValue = num, formatAxis = compactAxis, curve = "monotone",
  animate = false, animationDuration = 700,
}) {
  if (!data.length || !series.length) return <EmptyState />;
  const items = normaliseSeries(series);

  return (
    <ChartBox $height={height}>
      <ResponsiveContainer>
        <LineChart data={data} margin={CHART_MARGIN}>
          <CartesianGrid stroke={GRID} vertical={false} />
          <XAxis dataKey={xKey} {...xAxisProps} />
          <YAxis {...yAxisProps} tickFormatter={formatAxis} />
          <Tooltip content={<KitTooltip unit={unit} formatValue={formatValue} />} />
          {renderRefLines(refLines)}
          {items.map((s) => (
            <Line
              key={s.key}
              type={curve}
              dataKey={s.key}
              name={s.name}
              stroke={s.color}
              strokeWidth={s.strokeWidth ?? 2}
              strokeDasharray={s.dashed ? "5 4" : undefined}
              dot={s.dot ?? false}
              connectNulls={s.connectNulls ?? true}
              isAnimationActive={animate}
              animationDuration={animationDuration}
            />
          ))}
        </LineChart>
      </ResponsiveContainer>
    </ChartBox>
  );
}
